import http from "../http-common";
/* eslint-disable */
class AdminInfokomService {
  adminList(page, itemPerPage, keyword, komisariat, dpw, dpd) {
    return http.get(
      "/admin-infokom/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&komisariat_id=" +
        komisariat +
        "&dpw_id=" +
        dpw +
        "&dpd_id=" +
        dpd,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  adminNonList(page, itemPerPage, keyword, komisariat, dpw, dpd) {
    return http.get(
      "/admin-infokom-non/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&komisariat_id=" +
        komisariat +
        "&dpw_id=" +
        dpw +
        "&dpd_id=" +
        dpd,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  komisariatListAll() {
    return http.get("/komisariat/all", {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("user_id", data.id);

    return http.post("/admin-infokom", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(id, data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", id);
    bodyFormData.append("user_id", data.id);

    return http.put(`/admin-infokom/${id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/admin-infokom/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new AdminInfokomService();
